<template>
  <div>
    <div class="form-group">
      <Typeahead
        v-model="counterParty"
        label="Who is the Counterparty? (Business name)"
        :items="allAvailableCounterParties"
        :errors="$page.props.errors.counter_party_id"
        placeholder="Start typing to search..."
        :tolerance="0"
        return-field="id"
        id-field="id"
        search-field="name"
        display-field="name"
        @selected="counterPartySelected"
      >
        <template v-slot:item="slotProps">
          <span v-if="slotProps.match.name">
            {{ slotProps.match.name }}
            <br />
          </span>
          <strong v-if="slotProps.match.address"><small>Address: {{ slotProps.match.address }}</small></strong>
          <strong v-if="slotProps.match.phone"><small>Phone: {{ slotProps.match.phone }}</small></strong>
        </template>
        <template v-slot:noResults>
          <small>
            We couldn't find a match.
          </small>
        </template>
      </Typeahead>
    </div>

    <div v-if="changeRequestTypes" class="form-group">
      <Typeahead
        v-model="changeRequestType"
        :items="changeRequestTypes"
        label="Which type of document would you like to change?"
        placeholder="Start typing or use the dropdown"
        display-field="name"
        @selected="fetchContracts"
      >
        <template v-slot:item="slotProps">
          <span v-if="slotProps.match.name">
            {{ slotProps.match.name }}
          </span>
        </template>
      </Typeahead>
    </div>

    <div v-if="changeRequestType && contracts" class="form-group">
      <Typeahead
        v-model="selectedAsset"
        :errors="$page.props.errors.asset_id"
        :items="contracts"
        label="What specific document would you like to change?"
        placeholder="Start typing or use the dropdown"
        return-field="id"
        id-field="id"
        search-field="name"
        display-field="name"
        @selected="assetSelected"
      >
        <template v-slot:item="slotProps">
          <span v-if="slotProps.match.name">
            {{ slotProps.match.name }}
          </span>
        </template>
      </Typeahead>
    </div>

  </div>
</template>

<script>
import mixin from './mixin';
const moment = require('moment');

export default {
  mixins: [mixin],

  data() {
    return {
      counterPartiesData: this.counterParties,
      counterParty: null,
      selectedAsset: null,

      form: {
        counter_party_type: this.asset ? this.asset.counter_party_type : null,
        counter_party_id: this.asset ? this.asset.counter_party_id : null,
        asset_id: this.asset ? this.asset.asset_id : null,
        role: this.asset ? this.asset.role : null,
      },
      sending: false,
      fetching: false,
      contracts: null,

      changeRequestTypes: null,
      changeRequestType: null,
    };
  },

  computed: {
    allAvailableCounterParties() {
      const modifiedOrganisations = this.organisations.map((org) => ({
        id: org.id,
        type: 'App\\Models\\Organisation',
        name: org.name,
      }));

      const modifiedCounterParties = this.counterPartiesData.map((cp) => ({
        id: cp.id,
        type: 'App\\Models\\CounterParty',
        name: cp.name,
        address: cp.address,
        phone: cp.phone,
      }));

      return [...modifiedOrganisations, ...modifiedCounterParties].filter((org) => org.id);
    },
  },

  methods: {
    counterPartySelected(cp) {
      this.$page.props.errors.counter_party_id = null;

      if (cp) {
        this.form.counter_party_id = cp.id;
        this.form.counter_party_type = cp.type;
        this.fetchAssetTypes();
      } else {
        this.form.counter_party_id = null;
        this.form.counter_party_type = null;
        this.changeRequestTypes = null;
      }
    },

    assetSelected(asset) {
      this.$page.props.errors.asset_id = [];

      if (asset) {
        this.form.asset_id = asset.id;
        this.form.role = asset.role;
      } else {
        this.form.asset_id = null;
        this.form.role = null;
      }
    },

    fetchAssetTypes() {
      window.axios
        .get(this.route('counter-party.asset-types.executed', [this.form.counter_party_id]))
        .then((response) => {
          this.fetching = false;
          this.changeRequestTypes = response.data;
        });
    },

    fetchContracts() {
      if (this.changeRequestType) {
        window.axios
          .get(this.route('counter-party.asset.index', [this.form.counter_party_id, this.changeRequestType.slug]))
          .then((response) => {
            this.fetching = false;
            this.contracts = response.data.map((contract) => {

              return {
                ...contract,
                name: `${contract.name} dated ${this.$options.filters.localDate(contract.signatures[0].signed_at)}`
              }
            });
          });
      }
    },
  },
};
</script>
